import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
// import SVG from 'react-inlinesvg';
import AdHocInvoiceModal from '../common/AdHocInvoiceModal/AdHocInvoiceModal';
// import chevronDown from '../../../assets/images/icons/chevronDown.svg';
import { deleteRequest } from '../../requestUtils';
import './ViewAdHocInvoiceDropdown.scss';

function ViewAdHocInvoiceDropdown({
  triggerText,
  csrfToken,
  projectId,
  companyName,
  projectName,
  consultantFullName,
  adHocInvoicesUrl,
  invoice,
}) {
  const handleDelete = () => deleteRequest(
    `${adHocInvoicesUrl}/${invoice.resource_id}`,
    csrfToken,
  ).then(() => {
    window.location.reload();
  }).catch(() => {});

  return (
    <Dropdown className="view-invoice-dropdown">
      <Dropdown.Toggle
        className="btn-dropdown-toggle"
        variant="primary"
      >
        {triggerText}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item href="#">
          <AdHocInvoiceModal
            csrfToken={csrfToken}
            projectId={projectId}
            modalHeader={`Edit Ad-Hoc Invoice ID ${invoice.id}`}
            triggerText="Edit"
            formMode="Edit"
            companyName={companyName}
            projectName={projectName}
            consultantFullName={consultantFullName}
            adHocInvoicesUrl={adHocInvoicesUrl}
            invoice={invoice}
            handleDelete={handleDelete}
          />
        </Dropdown.Item>
        <Dropdown.Item href="#">
          <button
            type="button"
            className="btn-delete"
            onClick={handleDelete}
          >
            Delete
          </button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

ViewAdHocInvoiceDropdown.propTypes = {
  triggerText: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  companyName: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  consultantFullName: PropTypes.string.isRequired,
  adHocInvoicesUrl: PropTypes.string.isRequired,
  invoice: PropTypes.shape({}).isRequired,
};

ViewAdHocInvoiceDropdown.defaultProps = {};

export default ViewAdHocInvoiceDropdown;
